var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 0H0V96H96V0ZM48 14.4C55.968 14.4 62.4 20.832 62.4 28.8C62.4 36.768 55.968 43.2 48 43.2C40.032 43.2 33.6 36.768 33.6 28.8C33.6 20.832 40.032 14.4 48 14.4ZM48 82.56C42.2969 82.5601 36.6825 81.1487 31.6573 78.4519C26.6322 75.7551 22.3525 71.8566 19.2 67.104C19.344 57.552 38.4 52.32 48 52.32C57.552 52.32 76.656 57.552 76.8 67.104C73.6475 71.8566 69.3678 75.7551 64.3427 78.4519C59.3175 81.1487 53.7031 82.5601 48 82.56Z",
    fill: "#DDDFE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageProfile);
export default __webpack_public_path__ + "static/media/image-profile.548dcb01fdf37a39f49e0b166f15739d.svg";
export { ForwardRef as ReactComponent };